import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'orEwPDk6gAWPNeZxTa7SYHzGeovIHNDf',
  scrollWheelZoom:true
})

Vue.use(ElementUI);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 动态修改网页标题 发易发
  if(store.state.webType == 'mf') {
    document.title = to.meta.title || '魅服科技';
  }else {
    document.title = to.meta.title || '发易发';
  }

  // 动态修改网页描述
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || '默认描述');
  }

  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
